import React, { useContext, useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { OrganizationChart } from 'primereact/organizationchart';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import HtlAgnOffresEdit from "./HtlAgnOffresEdit";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $rulPernId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
  ) {
    tbl_rules_prn(
      where: {
        id_seq: { _eq: $rulPernId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
    ) {
      id_seq
      firm_main_code
      firm_sub_code
      rules_class
      rules_type
      rules_name
      start_date
      end_date
      status
      active
    }
    tbl_rules_sub(where: { r_prn_id_seq: { _eq: $rulPernId } }) {
      id_seq
      r_prn_id_seq
      firm_main_code
      firm_sub_code
      rules_sub_type
      rules_sub_name
      start_date
      end_date
      status
      active
    }
      tbl_rules_sub_premises(where: { r_prn_id_seq: { _eq: $rulPernId } }) {
        id_seq
        r_prn_id_seq
        r_sub_id_seq
        firm_main_code
        firm_sub_code
        start_date_v1
        end_date_v1
        start_date_v2
        end_date_v2
        pre_type
        opr_1
        int_var_1
      }
      tbl_rules_act(where: { r_prn_id: { _eq: $rulPernId } }) {
        id_seq
        r_sub_id
        r_prn_id
        r_pre_id
        firm_main_code
        firm_sub_code
        act_class
        act_type
        date_1
        start_date
        end_date
        pre_type
        opr_2
        str_var_1
        int_var_1
      }
    }
 
`;




const INSERT_SEA = gql`
  mutation InsertRules(
    $rulPernId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
    $ruleClass: String
    $ruleType: String

   
    
  ) {
    insert_tbl_rules_prn(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        id_seq: $rulPernId,
        rules_name: $rulesName,
        start_date: $startDate,
        end_date: $endDate,
        active: $fmActive,
        rules_class: $ruleClass,
        rules_type:  $ruleType,

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_RULES_CLS = gql`
  query MyQuery( $lang: String, $defType: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
      }
    ) {
      lang
      type
      code
      name
    }
  }
`;

const GET_RULES_TYP = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        opt_1: { _eq: $ruleClass },
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const UPDATE_RULES = gql`
mutation UpdateRules(
    $rulPernId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String
    $ruleClass: String
    $ruleType: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
    
  ) {
    update_tbl_rules_prn(
      where: {
        id_seq: { _eq: $rulPernId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        rules_class: $ruleClass
        rules_type: $ruleType
        rules_name: $rulesName
        active: $fmActive
        start_date: $startDate
        end_date: $endDate
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;






const HtlAgnOffChart = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

 

  const [firmData5] = useState([
    {
      label: 'Argentina',
      expanded: true,
      children: [
        {
          label: 'Argentina',
          expanded: true,
          children: [
            {
              label: 'Argentina',
            },
            {
              label: 'Croatia',
            },
          ],
        },
        {
          label: 'France',
          expanded: true,
          children: [
            {
              label: 'France',
            },
            {
              label: 'Morocco',
            },
          ],
        },
      ],
    },
  ]);

  
  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { rulPernId: varCode, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode },
  });
  
  const firmData = data && data.tbl_rules_prn ? data.tbl_rules_prn : [];
  const firmData2 = data && data.tbl_rules_sub ? data.tbl_rules_sub : [];


  const transformedData = useMemo(() => {
    if (error || !firmData || !data || !data.tbl_rules_sub) {
      return [];
    }
  
    return firmData.map((prnItem) => {
      const prnLabel = prnItem.rules_name;
  
      const subChildren = data.tbl_rules_sub
        .filter((subItem) => subItem.r_prn_id_seq === prnItem.id_seq)
        .map((filteredSubItem) => {
          const subLabel = filteredSubItem.rules_sub_type;
  
          // İlgili subItem'e ait premises kayıtlarını filtreleyerek al
          const premisesChildren = data.tbl_rules_sub_premises
            .filter((premisesItem) => premisesItem.r_sub_id_seq === filteredSubItem.id_seq)
            .map((filteredPremisesItem) => {
              const actChildren = data.tbl_rules_act
                .filter((actItem) => actItem.r_pre_id === filteredPremisesItem.id_seq)
                .map((filteredActItem) => ({
                  label: filteredActItem.act_type,
                }));
  
              return {
                label: filteredPremisesItem.pre_type,
                expanded: true,
                children: actChildren,
              };
            });
  
          return {
            label: subLabel,
            expanded: true,
            children: premisesChildren,
          };
        });
  
      return {
        label: prnLabel,
        expanded: true,
        children: subChildren,
      };
    });
  }, [firmData, data, error]);


 /* const transformedData = useMemo(() => {
    if (error || !firmData || !data || !data.tbl_rules_sub) {
      return [];
    }
  
    return firmData.map((prnItem) => {
      const prnLabel = prnItem.rules_name;
  
      const subChildren = data.tbl_rules_sub
        .filter((subItem) => subItem.r_prn_id_seq === prnItem.id_seq)
        .map((filteredSubItem) => {
          const subLabel = filteredSubItem.rules_sub_type;
  
          // İlgili subItem'e ait premises kayıtlarını filtreleyerek al
          const premisesChildren = data.tbl_rules_sub_premises
            .filter((premisesItem) => premisesItem.r_sub_id_seq === filteredSubItem.id_seq)
            .map((filteredPremisesItem) => ({
              label: filteredPremisesItem.pre_type,
            }));
  
          return {
            label: subLabel,
            expanded: true,
            children: premisesChildren,
          };
        });
  
      return {
        label: prnLabel,
        expanded: true,
        children: subChildren,
      };
    });
  }, [firmData, data, error]); */
  
  /*const transformedData = useMemo(() => {
    if (error || !firmData) {
      return [];
    }
  
    return firmData.map((prnItem) => {
      const prnLabel = prnItem.rules_name;
  
      const subChildren = (data.tbl_rules_sub || []).map((subItem) => {
        const subLabel = subItem.rules_sub_type;
  
        return {
          label: subLabel,
          expanded: true,
        };
      });
  
      return {
        label: prnLabel,
        expanded: true,
        children: [
          {
            label: prnItem.rules_name, // or label: subLabel, if you want to dynamically set it
            expanded: true,
            children: subChildren,
          },
        ],
      };
    });
  }, [firmData, firmData2, error]);*/

  
  const [firmData3, setFirmData3] = useState(transformedData);
  
 

  const [updateRulesPrn] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : false); 
 // const [seaDesc, setSeaDesc] = useState(firmData ? firmData.firm_sub_code_k : ""); 
  const [rulPernId, setRulPernId] = useState();
  const [rulesName, setRulesName] = useState(firmData ? firmData.rules_name : ""); 
  const [ruleClass, setRulesClass] = useState(firmData ? firmData.rules_class : ""); 
  const [ruleType, setRulesType] = useState(firmData ? firmData.rules_type : ""); 
  const [ruleClass2, setRulesClas2] = useState(); 

  
  
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const new_firm = messages[currentLocale].new_firm;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const per_id_title = messages[currentLocale].per_id_title;
  const per_code_title = messages[currentLocale].per_code_title;
  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const typerec = messages[currentLocale].typerec;


  



  const close_form = messages[currentLocale].close_form;
 
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const sea_new_btn = messages[currentLocale].sea_new_btn;
  const sea_Season_title = messages[currentLocale].sea_Season_title;
  
 
  const sea_management_title = messages[currentLocale].sea_management_title;
  const detail = messages[currentLocale].detail;
  
  const sea_id_title = messages[currentLocale].sea_id_title;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const sea_desc_title = messages[currentLocale].sea_desc_title;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_RULES_CLS, {
    variables: {lang: currentLocale, defType: "CLSR"},
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_RULES_TYP, {
    variables: {lang: currentLocale, defType: "TYPR", ruleClass: ruleClass},
  });


  


  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (rulPernId !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [rulPernId, setRulPernId]);


 

  useEffect(() => {
    if (firmData) {

        setRulesName(firmData.rules_name);
        setRulesClass(firmData.rules_class);
        
        setRulesType(firmData.rules_type);
  
        setRulPernId(firmData.id_seq);
        setStartDate(new Date(firmData.start_date));
        setEndDate(new Date(firmData.end_date));
        setFmActive(firmData.active);
      //  setSeaDesc(firmData.desc);
          
    }
  }, [firmData]);




  const handleUpdate = () => {
   
    
    updateRulesPrn({
      variables: {
        rulPernId: rulPernId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
       
        rulesName: rulesName,
        ruleClass: ruleClass,
        ruleType: ruleType,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        fmActive: fmActive,

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['rulesName', 'ruleClass', 'ruleType' ]; // Required fiels
    const customFieldNames = {
      rulesName: "Offer Name",
      ruleClass: "Rules Class",
      ruleType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setRulPernId(updatedIdSeq); 
        setVarCode(updatedIdSeq);
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulPernId);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {


        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        rulPernId: rulPernId,
        rulesName: rulesName,
        ruleClass: ruleClass,
        ruleType: ruleType,     
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        fmActive: fmActive
    
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  


 
  





  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">


<div className="card overflow-x-auto">
            <OrganizationChart value={transformedData} />
        </div>


        gjhgjhgj
     
    </div>




    
    
    
 
 
);
};

export default HtlAgnOffChart;
